import { Leaf, Blocks, Shield } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import VideoBackground from '../components/home/VideoBackground';

export default function Home() {
  return (
    <div className="relative">
      <Helmet>
        <title>Home | In Deep Water</title>
        <meta name="description" content="In Deep Water leads the way in sustainable coastal innovation with modular seawall systems designed to protect coasts and support marine life." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <VideoBackground />
      
      {/* Content container with higher z-index */}
      <div className="relative z-30 min-h-[100vh]">
        {/* Hero content */}
        <div className="relative max-w-7xl mx-auto px-8 pt-40 pb-32 min-h-screen flex flex-col justify-center">
          <div className="space-y-2">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-[#e1fefe] italic tracking-tight">
              In
            </h1>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-[#e1fefe] italic tracking-tight pl-8 md:pl-12 lg:pl-16">
              Deep 
            </h1>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-[#e1fefe] italic tracking-tight">
              Water
            </h1>
          </div>
          
          {/* Bottom tagline */}
          <div className="absolute bottom-20 right-8 md:right-16">
            <p className="text-white text-lg md:text-xl font-light">
              Finding new ways for the ocean to thrive
            </p>
          </div>
          
          {/* Scroll indicator */}
          <div className="absolute bottom-20 left-8">
            <div className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center cursor-pointer hover:border-white transition-colors">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        </div>

        {/* Features Section with gradient background */}
        <div className="relative">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-white" />
          
          {/* Content */}
          <div className="relative py-24 max-w-7xl mx-auto px-8">
            <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
              Key Features
            </h2>
            <div className="grid md:grid-cols-3 gap-12">
              {[
                {
                  icon: <Leaf className="h-14 w-14 text-teal-500" />,
                  title: 'Biodiversity Support',
                  description:
                    'Designed to create optimal habitats for marine life, promoting ecosystem diversity',
                },
                {
                  icon: <Blocks className="h-14 w-14 text-teal-500" />,
                  title: 'Modular Design',
                  description:
                    'Flexible, scalable solutions that adapt to different coastal environments',
                },
                {
                  icon: <Shield className="h-14 w-14 text-teal-500" />,
                  title: 'Coastal Protection',
                  description:
                    'Enhanced structural integrity for superior coastal defense',
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="text-center p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow"
                >
                  <div className="flex justify-center mb-6">{feature.icon}</div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 